import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class WeightLossProgram extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined
    this._employee_id = init.employee_id
    this._enrollment_date = init.enrollment_date
    this._id = init.id
    this._medication_names = init.medication_names
    this._member_declined = init.member_declined
    this._member_declined_reason = init.member_declined_reason
  }

  static shape = {
    employee_id: PropTypes.number,
    enrollment_date: PropTypes.string,
    id: PropTypes.number,
    medication_names: PropTypes.string,
    member_declined: PropTypes.bool,
    member_declined_reason: PropTypes.string
  }

  get employee_id() {
    return this._employee_id
  }

  get enrollment_date() {
    return this._enrollment_date
  }

  get id() {
    return this._id
  }

  get medication_names() {
    return this._medication_names
  }

  get member_declined() {
    return this._member_declined
  }

  get member_declined_reason() {
    return this._member_declined_reason
  }
}

export default WeightLossProgram
